<div class="sidebar-outer">
    <a class="logo d-flex align-items-center"   *ngIf="settings.theme.sidebarIsFixed">
        <span class="start"></span><span routerLink="/" (click)="closeSubMenus()" class="ng">Admin</span>
        <i *ngIf="settings.theme.showMenu==true" class="fa fa-times  align-self-center ml-auto" (click)="settings.theme.showMenu = !settings.theme.showMenu"></i>    
    </a>
    <app-vertical-menu  [menuItems]="menuItems"></app-vertical-menu>    
</div>